import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import CryptoJS from "crypto-js";

const generateCodeVerifier = () => {
  const array = new Uint8Array(32);
  window.crypto.getRandomValues(array);
  return Array.from(array, dec => ("0" + dec.toString(16)).substr(-2)).join("");
};

const generateCodeChallenge = async (verifier) => {
  if (window.crypto && window.crypto.subtle) {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest("SHA-256", data);
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
      .replace(/=/g, "")
      .replace(/\+/g, "-")
      .replace(/\//g, "_");
  } else {
    // Fallback for non-secure contexts (e.g. production HTTP)
    const hash = CryptoJS.SHA256(verifier);
    return hash.toString(CryptoJS.enc.Base64)
      .replace(/=/g, "")
      .replace(/\+/g, "-")
      .replace(/\//g, "_");
  }
};

const Login = () => {

  const [authUrl, setAuthUrl] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  // const params1=useSearchParams();
  useEffect(() => {
    localStorage.setItem("ref", 'login');
    const initAuthProcess = async () => {
      const verifier = generateCodeVerifier();
      localStorage.setItem("verifier", verifier);

      const launch = searchParams.get("launch");
      const challenge = await generateCodeChallenge(verifier);
      const params = new URLSearchParams({
        client_id: process.env.REACT_APP_CLIENT_ID,
        aud: process.env.REACT_APP_MELDRX_WS_URL,
        redirect_uri: process.env.REACT_APP_REDIRECT_URI,
        scope: "openid offline_access fhirUser user/*.read user/*.*",
        response_type: "code",
        code_challenge: challenge,
        code_challenge_method: "S256",
      })

      if (launch) {
        params.append('launch', launch)
      }

      const authLink = `${process.env.REACT_APP_MELDRX_BASE_URL}/connect/authorize?${params.toString()}`;
      setAuthUrl(authLink);
      window.location.href = authLink; // Redirect after setting state
    };

    initAuthProcess();
  }, []);

  return null; // No UI required since redirecting
};

export default Login;
